import { DeclineCategory, type DeclineDetail } from '../../models/insuranceIndication'

/** Staff label for each decline category. */
export const DECLINE_CATEGORY_LABELS: Record<DeclineCategory, string> = {
  [DeclineCategory.Appetite]: 'Appetite',
  [DeclineCategory.Geography]: 'Geography',
  [DeclineCategory.LossHistory]: 'Loss history',
  [DeclineCategory.DriverRecord]: 'Driver record',
  [DeclineCategory.OperatingHistory]: 'Operating history',
  [DeclineCategory.DataIncomplete]: 'Data incomplete',
  [DeclineCategory.AlreadyInsured]: 'Already insured',
  [DeclineCategory.NeedsInfo]: 'Needs info',
  // Staff label only; "Unknown" is the badge for a reason Cai cannot name.
  [DeclineCategory.Unknown]: 'Other',
}

export enum DeclineBadge {
  Unknown = 'Unknown',
  Final = 'Final',
  FixInPortal = 'Fix in portal',
  Fixable = 'Fixable',
}

export const DECLINE_BADGE_CLASSES: Record<DeclineBadge, string> = {
  [DeclineBadge.Unknown]: 'border-border bg-white text-foreground',
  [DeclineBadge.Final]: 'bg-secondary text-secondary-foreground',
  [DeclineBadge.FixInPortal]: 'border-blue-200 bg-blue-50 text-blue-700',
  [DeclineBadge.Fixable]: 'border-green-200 bg-green-50 text-green-800',
}

/** The badge for a decline from the backend's two flags; a card may refine Fixable further. */
export function declineBadge(detail: Pick<DeclineDetail, 'reasonKnown' | 'isActionable'>): DeclineBadge {
  if (!detail.reasonKnown) return DeclineBadge.Unknown
  if (!detail.isActionable) return DeclineBadge.Final
  return DeclineBadge.Fixable
}
